import React, { Component } from 'react';
import { connect } from 'react-redux';

import { OverlapsTable, TableFilter, NoReports, FirmReportHeader, TileLoader } from '../../../../components';
import { getOverlapsData } from '../../../../actions';
import icons from '../../../../assets/img/icons.svg';

class Overlaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOverlaps: null,
      filteredData: props.overlapsTableData,
    };
  }

  componentDidMount() {
    if (this.props.graphOf.id) {
      this.key = this.props.graphOf.id;
      this.getOverlapsDataFromAPI();
    }
    this.setState({ filteredData: this.props.overlapsTableData });
  }

  componentDidUpdate(prevProps) {
    if (this.props.graphOf.id && this.key !== this.props.graphOf.id) {
      this.key = this.props.graphOf.id;
      this.getOverlapsDataFromAPI();
    }
    if (prevProps.overlapsTableData !== this.props.overlapsTableData) {
      this.setState({ filteredData: this.props.overlapsTableData });
    }
  }

  /**
   * call Api to get data for overlaps
   */
  getOverlapsDataFromAPI = () => {
    if (this.props.graphOf && this.props.graphOf.id) {
      this.props.getOverlapsData(this.props.graphOf);
    }
  };

  // set global table filters
  setFilterProps = (filters) => {
    if (!this.state.searchOverlaps) this.setState({ searchOverlaps: filters.setGlobalFilter });
  };

  customFilter = (value) => {
    const { overlapsTableData } = this.props;
    let user;
    let filteredData = overlapsTableData.filter((item) => {
      let exist = item.target.toUpperCase().includes(value.toUpperCase());
      user = item.members.find((ele) => {
        const { first_name = '', last_name = '' } = ele;
        let name = first_name + last_name;
        return name.toUpperCase().includes(value.toUpperCase());
      });
      return exist || !!user;
    });
    this.setState({ filteredData });
  };

  openPopup = () => {
    this.props.openFirmPopup(true);
  };

  render() {
    const { overlapsTableData, loading } = this.props;
    const { filteredData } = this.state;
    return (
      <>
        <details
          className="report-params"
          open={this.props.reportParamsView === 'open' ? true : false}
          onToggle={this.props.handleReportParamsExpando}
        >
          <summary>
            <p>
              Viewing{' '}
              <b className="report-tag">
                <svg className="icon">
                  <use xlinkHref={`${icons}#org-${this.props.activeFirmGroupInfo.type}`} />
                </svg>{' '}
                {this.props.activeFirmGroupInfo.name}
              </b>
            </p>
          </summary>
          <div className="param org-view">
            <label>
              <span>View</span>
              <small>Select the Firm, a Group, or one User’s Pipeline.</small>
            </label>
            <div className="input-wrapper">
              <div className="value" onClick={() => this.openPopup()}>
                <div className="selection orgchart active">
                  <FirmReportHeader firmHeaderTitle={this.props.activeFirmGroupInfo} />
                  <div className="arrow">
                    <div className="caret-wrapper">
                      <div className="caret"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="presets">
                <small>
                  The{' '}
                  <b className="report-tag">
                    <svg className="icon">
                      <use xlinkHref={`${icons}#org-org`} />
                    </svg>{' '}
                    Firm
                  </b>{' '}
                  view shows Groups. The{' '}
                  <b className="report-tag">
                    <svg className="icon">
                      <use xlinkHref={`${icons}#org-group`} />
                    </svg>{' '}
                    Group
                  </b>{' '}
                  view shows Users in that Group.
                </small>
              </div>
            </div>
          </div>
        </details>
        <section className="panel table overlaps">
          {!overlapsTableData.length && loading && <TileLoader />}
          {overlapsTableData.length ? (
            <>
              <header className="filter">
                <TableFilter searchGlobal={this.state.searchOverlaps} customFilter={this.customFilter} />
              </header>
              <div className="scroller horz">
                <OverlapsTable
                  overlaps={filteredData}
                  headRows={overlapsTableData}
                  getFilterProps={this.setFilterProps}
                />
              </div>
            </>
          ) : (
            <NoReports loading={loading} />
          )}
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  graphOf: state.viewer.graphOf,
  overlapsTableData: state.overlapsTable.data || [],
  loading: state.overlapsTable.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getOverlapsData: (id) => dispatch(getOverlapsData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Overlaps);
